import React, { Component } from 'react'

export default class Cards extends Component {
    render() {
        return (
            <div>
                <div className="card">
                    <img src= {this.props.image} alt="" className="text-center"/>
                    <h1 className="heading">{this.props.headings}</h1>
                    {/* <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ducimus, dignissimos.</p> */}
                </div>
            </div>
        )
    }
}
